import { useContext } from 'react'
import StateContext from 'contexts/StateContext'

const useGlobalState = () => useContext(StateContext)

export default useGlobalState
